import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z" />, 'SkipNext');
